import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './salesdriving.json'; 

const SalesDriving = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Sales techniques, persuasion, and business development vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="A2"
            title="Sales Driving"
            image="/Images/salesdriving.webp"
            seoTitle="Free English Lesson Plans: Sales and Driving"
            seoDescription="Sales techniques, persuasion, and business development vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default SalesDriving;


